import React, { useMemo } from "react";
import { Chip } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  chipRoot: {
    height: "100%",
    marginRight: "2px",
  },
  chipLabel: {
    overflowWrap: "break-word",
    whiteSpace: "normal",
    textOverflow: "clip",
    paddingTop: "0.25rem",
    paddingBottom: "0.25rem",
    textAlign: "left",
  },
}));

const getEmpData = () => {
  try {
    const data = localStorage.getItem("employees");
    if (!data) return [];
    const parsed = JSON.parse(data);
    if (!Array.isArray(parsed)) return [];
    return parsed;
  } catch (e) {
    return [];
  }
};

const AnswerChip = ({ label, selectedAns = "", type = "" }) => {
  const classes = useStyles();

  // EmpData is loaded on every render to prevent stale data issues
  const empData = useMemo(() => getEmpData(), []);

  // Sometimes IDs could be string or number, so compare loosely
  const selectedEmpName = useMemo(() => {
    if (type !== "employees" || !selectedAns) return null;
    let match = empData.find(
      (emp) =>
        emp?.id === selectedAns || String(emp?.id) === String(selectedAns)
    );
    return match?.name || selectedAns;
  }, [empData, selectedAns, type]);

  // If for some reason the name can't be resolved, fallback to label or to the selectedAns itself
  return (
    <Chip
      label={
        type === "employees" ? selectedEmpName || label || selectedAns : label
      }
      variant="outlined"
      classes={{
        root: classes.chipRoot,
        label: classes.chipLabel,
      }}
      style={{ color: 'initial' }}
    />
  );
};
export default AnswerChip;
